import React from 'react'

import ReviewPromptPopup from './ReviewPromptPopup'
import useReviewPromptTrigger from './useReviewPromptTrigger'

/** "Rate Approveit" prompt shown after approvals made in the Teams app (ADN-591). Teams-only: the web app never mounts it. */
const ReviewPrompt: React.FC = () => {
  const { isOpen, close } = useReviewPromptTrigger()

  return isOpen ? <ReviewPromptPopup onClose={close} /> : null
}

export default ReviewPrompt
